/**
 * @param {import("../../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/users/customers/messages",
    },
    (router) => {
      router.push({
        id: "@api/user.customer.message@search",
        path: "",
      });

      router.push({
        id: "@api/user.customer.message@create",
        path: "",
      });

      router.group(
        {
          path: "/:userCustomerMessageId",
        },
        (router) => {
          router.push({
            id: "@api/user.customer.message@show",
            path: "",
          });
          router.push({
            id: "@api/user.customer.message@update",
            path: "",
          });
          router.push({
            id: "@api/user.customer.message@delete",
            path: "",
          });
        },
      );
    },
  );
}
